import { CorpAuth } from "models/Auth";

export const setCorpAuth = (payload: CorpAuth) => ({
  type: "auth/corp/SET_CORP_AUTH" as const,
  payload: payload
});

export type AuthCorpAction = ReturnType<typeof setCorpAuth>;
